import {make} from 'vuex-pathify'

const state = {
  previousDisabled: false,
  nextDisabled: false,
  finishAndViewTasks: false,
  finishAndEditTasks: false
}

const getters = make.getters(state)
const mutations = make.mutations(state)

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
